<script setup lang="ts">
  import { MpButton, MpCard, MpText } from '@borg/ui';

  defineProps<{
    actionText: string;
    confirmText: string;
    cancelText: string;
    isLoading: boolean;
  }>();

  const emit = defineEmits<{
    cancel: [];
    confirm: [];
  }>();
</script>

<template>
  <MpCard
    class="success-action-card"
    border
  >
    <MpText as="h5">
      {{ actionText }}
    </MpText>
    <div class="success-action-card__options">
      <MpButton
        :text="cancelText"
        :disabled="isLoading"
        variant="ghost"
        @click="emit('cancel')"
      />
      <MpButton
        :text="confirmText"
        :is-loading="isLoading"
        :disabled="isLoading"
        @click="emit('confirm')"
      />
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .success-action-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--mp-space-60);
    margin-top: var(--mp-space-100);

    &__options {
      display: flex;
      gap: var(--mp-space-30);
    }
  }
</style>
